import { render, staticRenderFns } from "./LimitSaleForm.vue?vue&type=template&id=2bf015cf&scoped=true"
import script from "./LimitSaleForm.vue?vue&type=script&lang=js"
export * from "./LimitSaleForm.vue?vue&type=script&lang=js"
import style0 from "./LimitSaleForm.vue?vue&type=style&index=0&id=2bf015cf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf015cf",
  null
  
)

export default component.exports